import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const DisableIcon = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.883}
      d="M8 15.063A7.063 7.063 0 1 0 8 .937a7.063 7.063 0 0 0 0 14.126ZM12.855 3.145l-9.71 9.71"
    />
  </Svg>
)
export default DisableIcon
